module.exports = __webpack_public_path__ + "static/basis-grotesque-regular-pro-5f327a4e3950ab92e1f7c8033f451afb.otf";